<template>
    <v-card class='pa-3 mb-3'>
        <v-card-text class='pb-1'>
            <v-row>
                <v-col lg=6>
                    <v-card-title class='pt-0'><h3>Ordered on {{order_date}}</h3></v-card-title>
                    <v-card-subtitle><b>Bill Total:</b> Rs. {{bill_total}}</v-card-subtitle>
                    <div class='ml-2'>
                        <v-badge v-for="product in order_items" :key="product.id" :content="product.qty" overlap bottom class='ml-3 mb-3'>
                            <v-avatar tile >
                                <v-img :src="order_items[0].product_img"></v-img>
                            </v-avatar>
                        </v-badge>                                  
                    </div>
                </v-col>
                <v-col lg=6>
                    <p class='mb-0'>Delivery Status:</p>
                        <h3 class='success--text' v-if='!is_delivered'>To Be Delivered </h3>
                        <h3 v-else>Delivered</h3>
                    <br>
                    <p>Delivery Address: <br>{{delivery_address.address1}}, <br>{{delivery_address.address2}}, <br>{{delivery_address.city}}, <br>{{delivery_address.state}} <br>PIN Code: {{delivery_address.pincode}}</p>     
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions class='d-flex justify-end'>
            <v-btn color='error' text small v-if='!is_delivered'>Cancel Order</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
    name:'MyOrderCard',
    props:['bill_total','order_date', 'is_delivered','order_items','delivery_address']
}
</script>